module.exports = {
  type: 'selector',
  id: 'model',
  icon: 'fad fa-cube',
  title: {
    de: 'Modell',
    en: 'Model'
  },
  showIf: {
    doModel: 'yes',
  },
  form: [
    {
      id: 'doModel',
      type: 'switch',
      checkValue: 'yes',
      label: {
        en: 'I want to order 3d printed models',
        de: 'Ich möchte 3D-gedruckte Modelle bestellen',
      }
    },
    {
      id: 'model',
      type: 'tiles',
      required: true,
      label: {
        de: 'Modell auswählen',
        en: 'Select model'
      },
      showIf: {
        doModel: 'yes',
      },
      cols: 3,
      options: [
        // {
        //   value: 'none',
        //   label: {
        //     de: 'Kein Modell',
        //     en: 'No model'
        //   },
        //   imageUrl: '/img/jaws/no-model.png',
        // },
        {
          value: 'upper',
          label: {
            de: 'Oberkiefer',
            en: 'Upper jaw'
          },
          imageUrl: '/img/jaws/upper.png',
          itemnum: 'S-000039',
        },
        {
          value: 'lower',
          label: {
            de: 'Unterkiefer',
            en: 'Lower jaw'
          },
          imageUrl: '/img/jaws/lower.png',
          itemnum: 'S-000039',
        },
        {
          value: 'both',
          label: {
            de: 'Vollmodell',
            en: 'Full jaw'
          },
          imageUrl: '/img/jaws/both.png',
          itemnum: ['S-000039','S-000039']
        }
      ]
    }, {
      id: 'add-articulator',
      label: {
        de: 'Artikulator hinzufügen',
        en: 'Add articulator',
      },
      requires: {
        model: 'both'
      },
      type: 'switch',
      itemnum: 'S-000000',
      checkValue: '1'
    }
  ],

  info: {
    de: 'Bitte wählen Sie entnehmbare Stümpfe',
    en: 'Please select ejectable stumps',
  },

  teethView: 'top',
  layers: [
    {
      defaultItems: {
        'S-000003': 1
      },
      label: {
        de: 'Stümpfe',
        en: 'Stumps'
      },
      range: 1,
      required: false,
      maxunits: 32,
      id: 'stumps',
      applyTo: 'both',
      text: 'x',
      color: 'transparent',
      textColor: 'red',
      showIf: {
        model: 'both'
      }
    },
    {
      defaultItems: {
        'S-000003': 1
      },
      label: {
        de: 'Stümpfe',
        en: 'Stumps'
      },
      range: 1,
      required: false,
      maxunits: 32,
      id: 'stumps',
      applyTo: 'lower',
      text: 'x',
      color: 'transparent',
      textColor: 'red',
      showIf: {
        model: 'lower'
      },
    },
    {
      defaultItems: {
        'S-000003': 1
      },
      label: {
        de: 'Stümpfe',
        en: 'Stumps'
      },
      range: 1,
      required: false,
      maxunits: 32,
      id: 'stumps',
      applyTo: 'upper',
      text: 'x',
      color: 'transparent',
      textColor: 'red',
      showIf: {
        model: 'upper'
      },
    }
  ]
}
